"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitStylesFromProps = exports.allStyleProps = exports.styleFunctionsMap = exports.mapZindexPropstoClassName = exports.mapShadowPropsToClassName = exports.mapBorderPropsToClassName = exports.mapPositionPropsToClassName = exports.mapTypographyPropsToClassName = exports.mapFlexPropsToClassName = exports.mapColorPropsToClassName = exports.mapMarginPropsToClassName = exports.mapPaddingPropsToClassName = exports.mapSizePropsToClassName = exports.createClassNameGenerator = exports.createClassNamesFromPrefix = void 0;
const classnames_1 = __importDefault(require("classnames"));
const createClassNamesFromPrefix = (prefix, value) => {
    if (!value && value !== 0) {
        return '';
    }
    if (Array.isArray(value)) {
        const valueForAll = value[0];
        return classnames_1.default(value[1] && `sm:${prefix}-${value[1]}`, value[2] && `md:${prefix}-${value[2]}`, value[3] && `lg:${prefix}-${value[3]}`, value[4] && `xl:${prefix}-${value[4]}`, `${prefix}-${valueForAll}`);
    }
    else {
        return `${prefix}-${value}`;
    }
};
exports.createClassNamesFromPrefix = createClassNamesFromPrefix;
const propNameToPrefixMap = {
    padding: 'pa',
    paddingX: 'px',
    paddingY: 'py',
    zIndex: 'zi',
    paddingLeft: 'pl',
    paddingRight: 'pr',
    paddingTop: 'pt',
    paddingBottom: 'pb',
    margin: 'ma',
    marginX: 'mx',
    marginY: 'my',
    marginLeft: 'ml',
    marginRight: 'mr',
    marginTop: 'mt',
    marginBottom: 'mb',
    width: 'w',
    elevation: 'bs',
    borderRadius: 'br',
    fontSize: 'f',
    fontWeight: 'fw',
    fontFamily: 'ff',
    lineHeight: 'lh',
    background: 'bg',
    backgroundHover: 'bgh',
    borderColor: 'bc',
    color: 'cl',
    justifyContent: 'jc',
    alignItems: 'ai',
    wrap: 'fw',
    alignSelf: 'as',
    direction: 'fd',
    position: 'p',
    height: 'h',
    top: 't',
    left: 'l',
    bottom: 'b',
    right: 'r'
};
const sizeProps = ['width', 'height'];
const borderProps = ['borderRadius', 'borderColor'];
const shadowProps = ['elevation'];
const paddingProps = [
    'padding',
    'paddingX',
    'paddingY',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom'
];
const marginProps = [
    'margin',
    'marginX',
    'marginY',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
const typographyProps = ['fontSize', 'fontWeight', 'lineHeight', 'fontFamily'];
const flexProps = [
    'alignItems',
    'justifyContent',
    'wrap',
    'direction',
    'alignSelf'
];
const colorProps = ['background', 'color', 'backgroundHover'];
const positionProps = ['position', 'top', 'left', 'bottom', 'right'];
const zIndexProps = ['zIndex'];
const createClassNameGenerator = (propSet) => (props) => {
    const classNames = propSet
        .map((key) => ({
        prefix: propNameToPrefixMap[key],
        value: props[key]
    }))
        .filter((el) => el.prefix !== undefined)
        .map((record) => exports.createClassNamesFromPrefix(record.prefix, record.value));
    return classNames.join(' ').trim();
};
exports.createClassNameGenerator = createClassNameGenerator;
exports.mapSizePropsToClassName = exports.createClassNameGenerator(sizeProps);
exports.mapPaddingPropsToClassName = exports.createClassNameGenerator(paddingProps);
exports.mapMarginPropsToClassName = exports.createClassNameGenerator(marginProps);
exports.mapColorPropsToClassName = exports.createClassNameGenerator(colorProps);
exports.mapFlexPropsToClassName = exports.createClassNameGenerator(flexProps);
exports.mapTypographyPropsToClassName = exports.createClassNameGenerator(typographyProps);
exports.mapPositionPropsToClassName = exports.createClassNameGenerator(positionProps);
exports.mapBorderPropsToClassName = exports.createClassNameGenerator(borderProps);
exports.mapShadowPropsToClassName = exports.createClassNameGenerator(shadowProps);
exports.mapZindexPropstoClassName = exports.createClassNameGenerator(zIndexProps);
exports.styleFunctionsMap = {
    sizing: exports.mapSizePropsToClassName,
    padding: exports.mapPaddingPropsToClassName,
    margin: exports.mapMarginPropsToClassName,
    color: exports.mapColorPropsToClassName,
    flex: exports.mapFlexPropsToClassName,
    typography: exports.mapTypographyPropsToClassName,
    position: exports.mapPositionPropsToClassName,
    shadow: exports.mapShadowPropsToClassName,
    border: exports.mapBorderPropsToClassName,
    'z-index': exports.mapZindexPropstoClassName
};
exports.allStyleProps = [
    ...colorProps,
    ...sizeProps,
    ...flexProps,
    ...typographyProps,
    ...positionProps,
    ...paddingProps,
    ...marginProps,
    ...borderProps,
    ...shadowProps,
    ...zIndexProps
];
const omitStylesFromProps = (props) => {
    return Object.keys(props)
        .filter(key => exports.allStyleProps.indexOf(key) < 0)
        .reduce((acc, val) => {
        return Object.assign(Object.assign({}, acc), { [val]: props[val] });
    }, {});
};
exports.omitStylesFromProps = omitStylesFromProps;
